
import React, { useState, useEffect } from 'react';
import { getMovies } from '../../services/mongoApi';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import {
  Container,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Card,
  CardMedia,
} from '@mui/material';

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
const months = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
const weeks = [1, 2, 3, 4];

const Releases = () => {
  const [movies, setMovies] = useState([]);
  const [releaseType, setReleaseType] = useState('ott_release_date'); // 'ott_release_date' or 'release_date'
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(months[new Date().getMonth()]);
  const [week, setWeek] = useState(Math.ceil(new Date().getDate() / 7));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMovies = async () => {
      setLoading(true);
      try {
        const params = {
          year,
          month,
          week,
          limit: 30,
          date_field: releaseType,
          sort_by: releaseType,
          filter: releaseType === 'ott_release_date' ? 'has_ott_release_date' : 'has_release_date',
        };
        const data = await getMovies(params);
        setMovies(data.movies);
      } catch (error) {
        console.error('Error fetching movies:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  }, [releaseType, year, month, week]);

  const handleReleaseTypeChange = (event, newReleaseType) => {
    if (newReleaseType !== null) {
      setReleaseType(newReleaseType);
    }
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        Releases
      </Typography>

      <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
        <Grid item>
          <ToggleButtonGroup
            value={releaseType}
            exclusive
            onChange={handleReleaseTypeChange}
            aria-label="release type"
          >
            <ToggleButton value="ott_release_date" aria-label="digital releases">
              Digital
            </ToggleButton>
            <ToggleButton value="release_date" aria-label="theater releases">
              Theater
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid item>
          <FormControl>
            <InputLabel>Year</InputLabel>
            <Select value={year} onChange={(e) => setYear(e.target.value)}>
              {years.map((y) => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl>
            <InputLabel>Month</InputLabel>
            <Select value={month} onChange={(e) => setMonth(e.target.value)}>
              {months.map((m) => (
                <MenuItem key={m} value={m}>{m}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl>
            <InputLabel>Week</InputLabel>
            <Select value={week} onChange={(e) => setWeek(e.target.value)}>
              {weeks.map((w) => (
                <MenuItem key={w} value={w}>{w}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={5}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 10 },
            480: { slidesPerView: 2, spaceBetween: 20 },
            640: { slidesPerView: 3, spaceBetween: 30 },
            1024: { slidesPerView: 5, spaceBetween: 30 },
          }}
        >
          {movies.map((movie) => (
            <SwiperSlide key={movie.id}>
              <Card>
                <CardMedia
                  component="img"
                  image={movie.poster}
                  alt={movie.name}
                  style={{ height: '450px', objectFit: 'cover' }}
                />
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </Container>
  );
};

export default Releases;
